import { MembersActionTypes, MembersState } from 'types';
import { Reducer } from 'redux';

const initialState: MembersState = {
  loading: false,
  error: '',
  paginationInfo: {},
  selected: null,
  orgListByBoundary: []
};

const reducer: Reducer<MembersState> = (state = initialState, action: any) => {
  switch (action.type) {
    case MembersActionTypes.FETCH_MEMBER_SEARCH_START: {
      return {
        ...state,
        loading: true
      };
    }
    case MembersActionTypes.FETCH_MEMBER_START: {
      return {
        ...state,
        loading: true
      };
    }
    case MembersActionTypes.FETCH_MEMBER_SUCCESS: {
      const { Info, Organisations } = action.payload;
      return {
        ...state,
        loading: false,
        paginationInfo: { ...Info },
        selected: Organisations
      };
    }
    case MembersActionTypes.FETCH_MEMBER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case MembersActionTypes.CLEAR_SELECTED_MEMBER:
      return {
        ...state,
        loading: false,
        selected: null
      };
    case MembersActionTypes.FETCH_MEMBER_SEARCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case MembersActionTypes.SET_ORG_LIST_BY_BOUNDARY_START: {
      return {
        ...state,
        loading: true
      };
    }
    case MembersActionTypes.SET_ORG_LIST_BY_BOUNDARY_SUCCESS: {
      const { Organisations } = action.payload;
      return {
        ...state,
        loading: false,
        orgListByBoundary: Organisations
      };
    }
    case MembersActionTypes.SET_ORG_LIST_BY_BOUNDARY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case MembersActionTypes.REMOVE_ERROR: {
      return {
        ...state,
        error: ''
      };
    }
    default:
      return state;
  }
};

export { reducer as MembersReducer };
